// Formation.js
import styled from 'styled-components';
import azure from '../images/azure.png';
import python from '../images/python.png';
import db from '../images/db.png';
import aws from '../images/aws.png';
import devOps from '../images/devOps.png';
import gestion from '../images/gestion.png';
import gouvernance  from '../images/gouvernance.png';
import agile  from '../images/agile.png';
import dbt  from '../images/dbt.png';
import security from '../images/security.png';

const formations = [
  {
    title: "Azure Data Engineer Bootcamp",
    description: "Développez votre expertise Azure en ingénierie des données. De la conception à la mise en production, maîtrisez les outils essentiels pour construire des solutions data robustes et évolutives.",
    image: azure
  },
  {
    title: "Big Data avec Spark et Python",
    description: "Exploitez la puissance du Big Data avec Apache Spark et Python. Apprenez à concevoir et déployer des applications distribuées pour l'analyse de données à grande échelle.",
    image: python
  },
  {
    title: "Architecture des Pipelines de Données",
    description: "Créez des pipelines de données modernes et efficaces avec Python. Maîtrisez les techniques d'ingestion, de transformation et de déploiement pour des flux de données optimisés.",
    image: db
  },
  {
    title: "AWS Cloud Computing Avancé",
    description: "Plongez dans l'univers AWS et ses services innovants. Concevez des architectures cloud scalables et sécurisées pour vos applications modernes.",
    image: aws
  },
  {
    title: "Azure DevOps & Intégration Continue",
    description: "Modernisez vos pratiques de développement avec Azure DevOps. Automatisez vos workflows et adoptez une approche DevOps complète pour vos projets.",
    image: devOps
  },
  {
    title: "Excellence des Données",
    description: "Établissez des standards de qualité data performants. Implémentez des processus de validation et de monitoring pour garantir l'intégrité de vos données.",
    image: gestion
  },
  {
    title: "Gouvernance Data Moderne",
    description: "Construisez un cadre de gouvernance data adapté aux enjeux actuels. Assurez conformité, sécurité et valorisation optimale de votre patrimoine data.",
    image: gouvernance 
  },
  {
    title: "Agilité & Data Projects",
    description: "Optimisez la gestion de vos projets data avec les méthodologies agiles. Améliorez la collaboration et l'efficacité de vos équipes data.",
    image: agile 
  },
  {
    title: "Snowflake & DBT Masterclass",
    description: "Optimisez votre data warehouse avec Snowflake et dbt. Construisez des pipelines de données modernes et maintenables pour vos analyses avancées.",
    image: dbt
  },
  {
    title: "Sécurité Cloud Avancée",
    description: "Protégez vos ressources cloud avec les meilleures pratiques de sécurité. Implémentez une stratégie de sécurité robuste pour vos applications et données.",
    image: security
  }
 ];


const Formation = () => {
  return (
    <FormationsContainer>
      <Header>
      <h1>Accélérez votre Expertise Digitale</h1>
 <p>
   Développez vos compétences technologiques avec nos formations expertes 
   en Data Science, Cloud Computing et Méthodes Agiles. Des programmes 
   conçus par des professionnels pour des professionnels.
 </p>
      </Header>

      <FormationsList>
        {formations.map((formation, index) => (
          <FormationCard key={index}>
           <ImageContainer className="image-container">
        <img src={formation.image} alt={formation.title} />
      </ImageContainer>
            <div className="content">
              <h2>{formation.title}</h2>
              <p>{formation.description}</p>
            </div>
          </FormationCard>
        ))}
      </FormationsList>

      {/* Partners Section et Call-to-action comme dans les autres pages 
      <PartnersSection />
      <CallToAction />*/}
    </FormationsContainer>
  );
};

export default Formation;

const FormationsContainer = styled.div`
  min-height: 100vh;
  color: white;
  padding: 4rem 2rem;
`;

const Header = styled.header`
   text-align: center;
  padding: 4rem 1rem;

  h1 {
    font-size: 3rem;
    margin-bottom: 1.5rem;
  }

  p {
    color: #94a3b8;
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.6;
  }
`;

const FormationsList = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
`;

const ImageContainer = styled.div`
  position: relative;
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
  
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    object-fit: contain;
    max-height: 300px;
  }
`;

const FormationCard = styled.div`
 display: grid;
 grid-template-columns: 1fr 1fr;
 gap: 4rem;
 margin-bottom: 8rem;
 align-items: center;
 padding: 0 2rem;

 .content {
   h2 {
     font-size: 2rem;
     margin-bottom: 2rem; // Augmentation de l'espacement
     color: #fff; // Pour s'assurer que le titre est bien visible
     font-weight: 600; // Optionnel: pour un titre plus prononcé
   }

   p {
     color: #94a3b8;
     line-height: 1.8;
     margin-bottom: 1.5rem;
   }
 }

 &:nth-child(odd) {
   ${ImageContainer} {
     order: 1;
   }
   .content {
     order: 2;
     text-align: left;
   }
 }

 &:nth-child(even) {
   ${ImageContainer} {
     order: 2;
   }
   .content {
     order: 1;
     text-align: left;
   }
 }

 @media (max-width: 768px) {
   grid-template-columns: 1fr;
   gap: 2rem;
   
   &:nth-child(odd),
   &:nth-child(even) {
     ${ImageContainer}, .content {
       order: unset;
       text-align: center;
     }
   }
 }
`;